import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {DiscountSearchPageComponent} from "./discount/discount-search-page/discount-search-page.component";
import {PriceLevelSearchPageComponent} from "./price-level/price-level-search-page/price-level-search-page.component";
import {SpecialSearchPageComponent} from "./special/special-search-page/special-search-page.component";
import {
    ProductSpecialMultiSelectSearchControlComponent
} from "./product-special/controls/product-special-multi-select-search-control.component";
import {SurchargeSearchPageComponent} from "./surcharge/surcharge-search-page/surcharge-search-page.component";
import {
    MixAndMatchSearchPageComponent
} from "./mix-and-match/mix-and-match-search-page/mix-and-match-search-page.component";
import {FrameworkModule} from "../framework/framework.module";
import {CatalogueSharedModule} from "../catalogue/catalogue.shared.module";
import {PriceLevelEditPageComponent} from "./price-level/price-level-edit-page/price-level-edit-page.component";
import {SurchargeEditPageComponent} from "./surcharge/surcharge-edit-page/surcharge-edit-page.component";
import {DiscountEditPageComponent} from "./discount/discount-edit-page/discount-edit-page.component";
import {MixAndMatchEditPageComponent} from "./mix-and-match/mix-and-match-edit-page/mix-and-match-edit-page.component";
import {PricingSharedModule} from "./pricing.shared.module";
import {SpecialEditPageComponent} from "./special/special-edit-page/special-edit-page.component";
import {CustomersSharedModule} from "../customers/customers.shared.module";
import {
    MixAndMatchInclusionSingleSelectEditControlComponent
} from "./mix-and-match/controls/mix-and-match-inclusion-single-select-edit-control.component";
import {
    MixAndMatchInclusionEditLinkColumnComponent
} from "./mix-and-match/controls/mix-and-match-inclusion-edit-link-column.component";
import {CustomObjectSharedModule} from "../custom-objects/custom-object.shared.module";
import {EntitlementSearchPageComponent} from "./entitlement/entitlement-search-page/entitlement-search-page.component";
import {EntitlementEditPageComponent} from "./entitlement/entitlement-edit-page/entitlement-edit-page.component";
import {PosSharedModule} from "../pos/pos.shared.module";
import {
    SchedulePromotionReportPageComponent
} from "./reports/schedule-promotion-report/schedule-promotion-report-page.component";
import {ReportsSharedModule} from "../reports/reports.shared.module";
import {
    SpecialScheduleSearchPageComponent
} from "./special-schedule/special-schedule-search-page/special-schedule-search-page.component";
import {
    PriceLevelScheduleSearchPageComponent
} from "./price-level-schedule/price-level-schedule-search-page/price-level-schedule-search-page.component";
import {
    MixAndMatchScheduleSearchPageComponent
} from "./mix-and-match-schedule/mix-and-match-schedule-search-page/mix-and-match-schedule-search-page.component";
import {
    PriceLevelScheduleEditPageComponent
} from "./price-level-schedule/price-level-schedule-edit-page/price-level-schedule-edit-page.component";
import {
    SpecialScheduleEditPageComponent
} from "./special-schedule/special-schedule-edit-page/special-schedule-edit-page.component";
import {
    MixAndMatchScheduleEditPageComponent
} from "./mix-and-match-schedule/mix-and-match-schedule-edit-page/mix-and-match-schedule-edit-page.component";
import {
    MixAndMatchInclusionEditFormComponent
} from "./mix-and-match/mix-and-match-edit-page/mix-and-match-inclusion-edit-form/mix-and-match-inclusion-edit-form.component";
import {SystemSharedModule} from "../system/system.shared.module";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        ReportsSharedModule,
        CustomObjectSharedModule,
        CatalogueSharedModule,
        PricingSharedModule,
        CatalogueSharedModule,
        CustomersSharedModule,
        PosSharedModule,
        SystemSharedModule
    ],
    declarations: [
        DiscountSearchPageComponent,
        DiscountEditPageComponent,
        EntitlementSearchPageComponent,
        EntitlementEditPageComponent,
        PriceLevelSearchPageComponent,
        PriceLevelEditPageComponent,
        PriceLevelScheduleSearchPageComponent,
        PriceLevelScheduleEditPageComponent,
        SpecialSearchPageComponent,
        SpecialEditPageComponent,
        SpecialScheduleSearchPageComponent,
        SpecialScheduleEditPageComponent,
        ProductSpecialMultiSelectSearchControlComponent,
        SurchargeSearchPageComponent,
        SurchargeEditPageComponent,
        MixAndMatchSearchPageComponent,
        MixAndMatchEditPageComponent,
        MixAndMatchInclusionEditFormComponent,
        MixAndMatchInclusionSingleSelectEditControlComponent,
        MixAndMatchInclusionEditLinkColumnComponent,
        MixAndMatchScheduleSearchPageComponent,
        MixAndMatchScheduleEditPageComponent,
        SchedulePromotionReportPageComponent
    ],
    exports: [
        DiscountSearchPageComponent,
        DiscountEditPageComponent,
        EntitlementSearchPageComponent,
        EntitlementEditPageComponent,
        PriceLevelSearchPageComponent,
        PriceLevelEditPageComponent,
        PriceLevelScheduleSearchPageComponent,
        PriceLevelScheduleEditPageComponent,
        SpecialSearchPageComponent,
        SpecialEditPageComponent,
        SpecialScheduleSearchPageComponent,
        SpecialScheduleEditPageComponent,
        ProductSpecialMultiSelectSearchControlComponent,
        SurchargeSearchPageComponent,
        SurchargeEditPageComponent,
        MixAndMatchSearchPageComponent,
        MixAndMatchEditPageComponent,
        MixAndMatchInclusionEditFormComponent,
        MixAndMatchInclusionSingleSelectEditControlComponent,
        MixAndMatchInclusionEditLinkColumnComponent,
        MixAndMatchScheduleSearchPageComponent,
        MixAndMatchScheduleEditPageComponent,
        SchedulePromotionReportPageComponent
    ]
})
export class PricingModule {

}
